import { TabNoteData } from "./resultTypes";
import styles from "./Results.module.css";
import { getResultNote } from "./resultUtils";

const strings = {
  label: "Result Note:",
};

export default function Note(props: TabNoteData) {
  if (props.tab === "NOPAYMENT") {
    return null;
  }

  return (
    <label>
      <div className={styles.label}>{strings.label}</div>
      <div className={styles.textareaContainer}>
        <textarea
          className={styles.textarea}
          rows={props.tab === "CSR" ? 2 : 4}
          readOnly={true}
          value={getResultNote(props)}
        />
      </div>
    </label>
  );
}
